document.addEventListener("DOMContentLoaded", function () {
  const zoomPreview = document.getElementById("productZoomPreview");

  if (!zoomPreview) return;

  document.body.addEventListener("mouseenter", function (e) {
    const img = e.target.closest(".product-media-image[data-zoom]");
    if (!img) return;

    const zoomSrc = img.dataset.zoom;

    zoomPreview.style.backgroundImage = `url(${zoomSrc})`;
    zoomPreview.style.backgroundSize = "200%";
    zoomPreview.style.display = "block";
  }, true);

  document.body.addEventListener("mousemove", function (e) {
    const img = e.target.closest(".product-media-image[data-zoom]");
    if (!img) return;

    const rect = img.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    zoomPreview.style.backgroundPosition = `${x}% ${y}%`;
  }, true);

  document.body.addEventListener("mouseleave", function (e) {
    const img = e.target.closest(".product-media-image[data-zoom]");
    if (!img) return;

    zoomPreview.style.display = "none";
  }, true);
});